module.exports = __webpack_public_path__ + "img/artboard3.96d56221.jpg";